module.exports = __webpack_public_path__ + "static/feature-team-activity-780df679661aefbf3e7038f36d982e14.png";